import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TemporalContextService } from '../../services/temporal-context.service';
import { AppConfigService } from '../../services/app-config.service';
import { DisplayDatePipe } from '../../pipes/display-date.pipe';

/**
 * "Time travel" mode banner — the mode's contract, shown on
 * EVERY in-mode route including interstitials. Date AND time always render,
 * viewer-local (a shared link near a day boundary can legitimately show a
 * different calendar day per viewer — the visible time makes both honest).
 *
 * Cloned from demo-banner (the banner-family canon; mounted app-root in the
 * demo/subscription/trial stack). Exit keeps history — back re-enters the mode.
 */
@Component({
  selector: 'app-temporal-banner',
  standalone: true,
  imports: [DisplayDatePipe, TranslateModule],
  templateUrl: './temporal-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './temporal-banner.component.scss'
})
export class TemporalBannerComponent {
  protected readonly temporal = inject(TemporalContextService);
  private readonly appConfig = inject(AppConfigService);

  protected readonly brandName = computed(() => this.appConfig.config$()?.brandName ?? '');

  protected exit(): void {
    void this.temporal.exit();
  }
}
